import React, { useState } from "react";
import {
  getCustomer,
  updateCustomer,
} from "../../../services/customer.services";

const AssignToAdminModal = ({
  admins,
  onClose,
  customerId,
  toggleModal,
  fetchLeads,
}) => {
  const [assignedAdmins, setAssignedAdmins] = useState({
    assigned_content_writer: "",
    assigned_application_manager: "",
    assigned_visa_manager: "",
    assigned_loan_manager: "",
  });

  const onAssign = async () => {
    try {
      await updateCustomer(customerId, assignedAdmins);
      // toggleModal();
      fetchLeads();
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAssignedAdmins((prevAssignedAdmins) => ({
      ...prevAssignedAdmins,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    onAssign(assignedAdmins); // Assign all selected admins
    onClose(); // Close the modal
  };

  const getselectedCustomer = async () => {
    const res = await getCustomer(customerId);
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-[2000] p-4">
      <div className="bg-gray-100 p-4 sm:p-6 rounded-lg w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl xl:max-w-3xl max-h-[90vh] overflow-y-auto">
        <h3 className="text-lg sm:text-xl text-black font-semibold mb-4 sm:mb-6">
          Assign to Admin
        </h3>

        {/* Assigned Fields */}
        <div className="space-y-3 sm:space-y-4">
          <div>
            <label
              className="block text-xs sm:text-sm text-black font-medium mb-1 sm:mb-2"
              htmlFor="assigned_content_writer"
            >
              Assigned Content Writer:
            </label>
            <select
              className="w-full p-2 sm:p-3 border text-xs sm:text-sm text-black border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="assigned_content_writer"
              value={assignedAdmins.assigned_content_writer}
              onChange={handleChange}
            >
              <option value="">Select Admin</option>
              {admins.map((admin) => (
                <option key={admin.admin_id} value={admin.admin_id}>
                  {admin.username}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label
              className="block text-xs sm:text-sm text-black font-medium mb-1 sm:mb-2"
              htmlFor="assigned_application_manager"
            >
              Assigned Application Manager:
            </label>
            <select
              className="w-full p-2 sm:p-3 border text-xs sm:text-sm text-black border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="assigned_application_manager"
              value={assignedAdmins.assigned_application_manager}
              onChange={handleChange}
            >
              <option value="">Select Admin</option>
              {admins.map((admin) => (
                <option key={admin.admin_id} value={admin.admin_id}>
                  {admin.username}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label
              className="block text-xs sm:text-sm text-black font-medium mb-1 sm:mb-2"
              htmlFor="assigned_visa_manager"
            >
              Assigned Visa Manager:
            </label>
            <select
              className="w-full p-2 sm:p-3 border text-xs sm:text-sm text-black border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="assigned_visa_manager"
              value={assignedAdmins.assigned_visa_manager}
              onChange={handleChange}
            >
              <option value="">Select Admin</option>
              {admins.map((admin) => (
                <option key={admin.admin_id} value={admin.admin_id}>
                  {admin.username}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label
              className="block text-xs sm:text-sm text-black font-medium mb-1 sm:mb-2"
              htmlFor="assigned_loan_manager"
            >
              Assigned Loan Manager:
            </label>
            <select
              className="w-full p-2 sm:p-3 border text-xs sm:text-sm text-black border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="assigned_loan_manager"
              value={assignedAdmins.assigned_loan_manager}
              onChange={handleChange}
            >
              <option value="">Select Admin</option>
              {admins.map((admin) => (
                <option key={admin.admin_id} value={admin.admin_id}>
                  {admin.username}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-0 mt-4 sm:mt-6">
          <button
            className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md sm:mr-2 text-sm sm:text-base order-2 sm:order-1"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm sm:text-base order-1 sm:order-2 transition-colors duration-200"
            onClick={handleSubmit}
          >
            Assign
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignToAdminModal;
